import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstWordTitleCase'
})
export class FirstWordTitleCasePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }
    const words = value.split(' ');
    const firstWord = words[0].charAt(0).toUpperCase() + words[0].slice(1);
    words[0] = firstWord;
    return words.join(' ');
  }

}
